module.exports = "/static/assets/7ab23a6df65da9d1bfdb825aa9307686.gif";